import { Locale } from '../locales'

type IOldDeploymentUrl = Record<string, Record<Locale, string>>

export const ExternalDeploymentUrl = {
    SHOP: {
        [Locale.DE_DE]: 'https://shop.neotaste.com/',
        [Locale.DE_AT]: 'https://shop.neotaste.com/',

        [Locale.EN_GB]: 'https://shop.neotaste.com/en',
        [Locale.EN_AT]: 'https://shop.neotaste.com/en',
        [Locale.EN_DE]: 'https://shop.neotaste.com/en',
        [Locale.EN_NL]: 'https://shop.neotaste.com/en',

        [Locale.NL_NL]: 'https://shop.neotaste.com/en',
    },

    TERMS_AND_CONDITIONS: {
        [Locale.DE_DE]: '/agb',
        [Locale.DE_AT]: '/agb',

        [Locale.EN_GB]: '/gb/terms-and-conditions',
        [Locale.EN_AT]: '/at/en/terms-and-conditions',
        [Locale.EN_DE]: '/de/en/terms-and-conditions',
        [Locale.EN_NL]: '/nl/en/terms-and-conditions',

        [Locale.NL_NL]: '/nl/algemene-voorwaarden',
    },

    PARTNER_REFERRAL: {
        [Locale.DE_DE]: '/partner-wirbt-partner',
        [Locale.DE_AT]: '/partner-wirbt-partner',

        [Locale.EN_GB]: '/gb/referral-program',
        [Locale.EN_AT]: '/at/en/referral-program',
        [Locale.EN_DE]: '/de/en/referral-program',
        [Locale.EN_NL]: '/nl/en/referral-program',

        [Locale.NL_NL]: '/nl/partner-werft-partner',
    },

    PARTNER_PRIVACY_POLICY: {
        [Locale.DE_DE]: '/agb-partner',
        [Locale.DE_AT]: '/agb-partner',

        [Locale.EN_GB]: '/gb/privacy-policy-partner',
        [Locale.EN_AT]: '/at/en/privacy-policy-partner',
        [Locale.EN_DE]: '/de/en/privacy-policy-partner',
        [Locale.EN_NL]: '/nl/en/privacy-policy-partner',

        [Locale.NL_NL]: '/nl/algemene-voorwaarden-partner',
    },

    PARTNER_SUPPORT: {
        [Locale.DE_DE]: 'https://share-eu1.hsforms.com/1enooRIiQToW9UbMSgnZ7MA2daeg3',
        [Locale.DE_AT]: 'https://share-eu1.hsforms.com/1enooRIiQToW9UbMSgnZ7MA2daeg3',

        [Locale.EN_GB]: 'https://share-eu1.hsforms.com/1dsefq2IVSbSBcUe0da4bAw2daeg3',
        [Locale.EN_AT]: 'https://share-eu1.hsforms.com/1dsefq2IVSbSBcUe0da4bAw2daeg3',
        [Locale.EN_DE]: 'https://share-eu1.hsforms.com/1dsefq2IVSbSBcUe0da4bAw2daeg3',
        [Locale.EN_NL]: 'https://share-eu1.hsforms.com/1dsefq2IVSbSBcUe0da4bAw2daeg3',

        [Locale.NL_NL]: 'https://share-eu1.hsforms.com/1lW0kMulMRvuPL7rPzii82Q2daeg3',
    },

    JOBS: {
        [Locale.DE_DE]: 'https://jobs.ashbyhq.com/neotaste',
        [Locale.DE_AT]: 'https://jobs.ashbyhq.com/neotaste',

        [Locale.EN_GB]: 'https://jobs.ashbyhq.com/neotaste',
        [Locale.EN_AT]: 'https://jobs.ashbyhq.com/neotaste',
        [Locale.EN_DE]: 'https://jobs.ashbyhq.com/neotaste',
        [Locale.EN_NL]: 'https://jobs.ashbyhq.com/neotaste',

        [Locale.NL_NL]: 'https://jobs.ashbyhq.com/neotaste',
    },
} satisfies IOldDeploymentUrl

export const SECRET_OLD_DEPLOYMENT_URLS = [ExternalDeploymentUrl.PARTNER_PRIVACY_POLICY]
